export default{data:function(){return{columnKeys:[]}},computed:{header:function(){return!!this.$slots.header},animated:function(){return!!this.$slots.animated},body:function(){return!!this.$slots.body}}};
